import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_APP_SMART_BANNER_CONFIG = defineFcm('mobile_app_smart_banner_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				appId: {
					type: 'string',
				},
				enabled: {
					type: 'boolean',
				},
			},
		}),
	)
	.withDefault({
		appId: '1144132710',
		enabled: false,
	})
	.toConfig({
		owner: 'squad-mobile',
		scope: 'corgi-front-end',
		context: 'All Site Pages (petition starters)',
		description:
			'This FC controls the inclusion of the Apple iOS Smart Banner META tag on all site pages, for users who are petition starters.',
		import: false,
		template: {
			appId: '1144132710',
			enabled: false,
		},
	});
